import { openkit } from "../../library/database";

export const addRoomToCart = async (
  entity,
  store,
  product,
  info,
  clientRequest
) => {
  let cartItem = {
    client_id: info.user.id,
    type: "lodge",
    product_id: product.id,
    status: "cart",
    adults: info.lodge?.adults || 0,
    children: info.lodge?.children || 0,
    quantity: info.lodge?.rooms,
    check_in: info.lodge?.checkIn.format(),
    check_out: info.lodge?.checkOut.format(),
    request: clientRequest,
  };

  await openkit.data.create("c_reservation_lines", cartItem);
};
